import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import * as firebase from 'firebase';

@Component({
  selector: 'app-all-complaints',
  templateUrl: './all-complaints.component.html',
  styleUrls: ['./all-complaints.component.css']
})
export class AllComplaintsComponent implements OnInit {

  month: string = "";
  feedbacks: Array<any> = [];

  users: any = {};

  posts: any = {};

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.month = params['month'];
      if (this.month) {
        this.filter();
      } else {
        this.getFeedbacks();
      }
    });

  }

  filter() {
    var monthNum = this.getMonth(this.month);

    var date = new Date();

    date.setMonth(monthNum, 1);

    date.setHours(0, 0, 1);

    var start = date.getTime();

    date.setMonth(monthNum + 1, 0);

    date.setHours(23, 59, 59);

    var end = date.getTime();

    this.getFeedbacks(start, end);
  }

  getFeedbacks(start?, end?) {
    var ref: any = firebase.database().ref('feedbacks');

    if (start) {
      ref = ref.orderByChild("timestamp")
        .startAt(start)
        .endAt(end);
    }

    ref.once("value")
      .then(snapshot => {
        var data = snapshot.val();

        if (!data) {
          this.feedbacks = [];
          return;
        }

        for (var key in data) {
          var temp = data[key];

          temp.key = key;

          if (!temp.closed) {
            if (!this.users[temp.uid]) {
              this.users[temp.uid] = {
                uid: temp.uid
              }

              this.getUser(temp.uid);
            }

            if (temp.postId) {
              if (!this.posts[temp.postId]) {
                this.posts[temp.postId] = {
                  key: temp.postId
                }

                this.getPost(temp.postId);
              }
            }

            this.feedbacks.push(temp);
          }
        }
      })
      .catch(err => {
        alert(err.message);
        console.log(err);
      });
  }

  getUser(uid) {
    firebase.database().ref(`/users/${uid}`)
      .once("value")
      .then(snapshot => {
        var user = snapshot.val();

        this.users[uid] = user;
      })
  }

  getPost(id) {
    firebase.database().ref(`/posts/${id}`)
      .once("value")
      .then(snapshot => {
        var post = snapshot.val();

        if (!this.users[post.uid]) {
          this.users[post.uid] = {
            uid: post.uid
          }

          this.getUser(post.uid);
        }

        this.posts[id] = post;
      })
  }

  toggleSuspend(id, status) {
    firebase.database().ref(`/posts/${id}/isSuspended`).set(status);

    this.posts[id].isSuspended = status;
  }

  closeComplaint(index) {
    firebase.database().ref(`/feedbacks/${this.feedbacks[index].key}/closed`).set(true);

    this.feedbacks.splice(index, 1);

    alert("Complaint closed");
  }

  getMonth(month) {
    switch (month) {
      case 'Jan':
        return 0;
      case 'Feb':
        return 1;
      case 'Mar':
        return 2;
      case 'Apr':
        return 3;
      case 'May':
        return 4;
      case 'Jun':
        return 5;
      case 'Jul':
        return 6;
      case 'Aug':
        return 7;
      case 'Sep':
        return 8;
      case 'Oct':
        return 9;
      case 'Nov':
        return 10;
      case 'Dec':
        return 11;
      default:
        return -1;
    }
  }

}
